const SLUG_TO_PRODUCT_GROUP = {
  marketing: 'MARKETING',
  sales: 'SALES',
  service: 'SERVICE',
  content: 'CONTENT',
  data: 'DATA',
  commerce: 'COMMERCE',
  suite: 'PLATFORM',
  'smart-crm': 'SMART_CRM',
  'marketing-plus': 'HUBSPOT_FOR_MARKETERS',
  crm: 'FREE'
};
export function getProductGroupBySlug(slug) {
  return SLUG_TO_PRODUCT_GROUP[slug.toLowerCase()];
}